export function replaceStoreRequest(store) {
  return {
    type: "REPLACE_STORE_REQUEST",
    store: store,
  };
}

export function startLoading() {
  return {
    type: "SET_LOADING",
    status: true,
  };
}

export function stopLoading() {
  return {
    type: "SET_LOADING",
    status: false,
  };
}

export function getStore() {
  return {
    type: "GET_STORE_REQUEST",
  };
}

export function replaceStoreSuccess(store) {
  return {
    type: "REPLACE_STORE_SUCCESS",
    store: store,
  };
}

export function saveNeighborhoods(neighborhoods) {
  return {
    type: "SAVE_NEIGHBORHOODS",
    neighborhoods,
  };
}

export function updateDeliveryCalcMethod(method) {
  return {
    type: "UPDATE_DELIVERY_CALC_METHOD",
    method,
  };
}

export function updateDeliveryFee(deliveryFee) {
  return {
    type: "UPDATE_DELIVERY_FEE",
    deliveryFee,
  };
}

export function saveDeliveryTime(deliveryTime) {
  return {
    type: "SAVE_DELIVERY_TIME",
    deliveryTime,
  };
}

export function saveDeliveryEnabled(isEnabled) {
  return {
    type: "SAVE_DELIVERY_ENABLED",
    isEnabled,
  };
}

export function saveTakeawayEnabled(isEnabled) {
  return {
    type: "SAVE_TAKEAWAY_ENABLED",
    isEnabled,
  };
}

export function updatePaymentMethods(methods) {
  return {
    type: "UPDATE_PAYMENT_METHODS",
    methods,
  };
}

export function updateAddress(address) {
  return {
    type: "UPDATE_ADDRESS",
    address,
  };
}

export function updateTemplate(template) {
  return {
    type: "UPDATE_TEMPLATE",
    template,
  };
}
